
import MessageBox from "../MessageBox.vue";
import {onBeforeMount, PropType, Ref, ref, watch} from "vue";
import {useRoute} from "vue-router";
import {Interest} from "../../../../../../domain/entities/entities";

export default {
  components: { MessageBox },
  props: {
    message: {
      required: true,
      type: String
    },
    animationIsReverse: {
      required: false,
      type: Boolean
    },
    interests: {
      required: true,
      type: Array as PropType<Interest[]>
    },
    userInterests: {
      required: true,
      type: Array as PropType<Interest[]>
    }
  },
  setup(props, { emit }) {
    const route = useRoute();

    /** Checks if up to 5 interests have been selected. */
    const hasEnough: Ref<boolean> = ref(false);

    const isTransitionFinished = ref(false);

    /** IDs of selected interests. */
    const selectedInterestsIDs: Ref<number[]> = ref([]);

    onBeforeMount(() => {
      if (props.userInterests.length) {
        const userInterestIDs: number[] = props.userInterests.map(
          (userInterest: Interest) => userInterest.id
        );
        userInterestIDs.forEach((userInterestID: number) => {
          if (!selectedInterestsIDs.value.includes(userInterestID)) {
            selectedInterestsIDs.value.push(userInterestID);
          } else return;
        });
      }

      if (selectedInterestsIDs.value.length === 5) {
        hasEnough.value = true;
      }
      emit("update:userInterests", selectedInterestsIDs.value);
    });

    /** Reset animations everytime I leave a step. */
    watch(
      () => route.params.step,
      () => {
        if (
          Number(route.params.step) === 4 ||
          Number(route.params.step) === 6
        ) {
          isTransitionFinished.value = false;
        }
      }
    );

    /** Function responsible for sending the IDs of the selected interests. */
    const selectInterest = (
      input: HTMLInputElement,
      interestID: number
    ): void => {
      if (input.checked) {
        selectedInterestsIDs.value.push(interestID);
        hasEnough.value = selectedInterestsIDs.value.length === 5;
      } else {
        const index = selectedInterestsIDs.value.indexOf(interestID);
        if (index !== -1) {
          selectedInterestsIDs.value.splice(index, 1);
        }
        hasEnough.value = selectedInterestsIDs.value.length === 5;
      }

      emit("update:userInterests", selectedInterestsIDs.value);
    };

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    return {
      isTransitionFinished,
      hasEnough,
      selectedInterestsIDs,
      selectInterest,
      fluctuate
    };
  }
};
